/**
 * Browser shim for stream-chat's `import FormData from 'form-data'`.
 * The npm `form-data` package resolves to a CJS file without a default ESM export in Vite.
 */
export default FormData
